import { Card, Checkbox, Icon, Loader, Button, Modal, Input, Grid, Select, FileDrop, DatePicker, InputLabel } from '@scuf/common';
import DataTable from '@scuf/datatable/dist/components/DataTable/DataTable';
import 'assets/scuf/datatable/honeywell-compact/theme.css';
import Alert from 'components/alert';
import { formatDate } from 'helpers';
import useFetch from 'helpers/hooks/useFetch';
import requestFile from 'helpers/requestFile';
import { RmaFilterModel, RmaModelLite, WorkOrderRmaLiteDto } from 'models';
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { FilterAtom, notificationAtom, REPAIR_CENTER, RmaLite, RMAFilesAtom, user } from 'resources';
import 'styles/repaircenter.scss';
import { useCookies } from 'react-cookie';
import { telephoneMask, cnpjMask } from 'resources';
import FilesModal from '../accordion/workOrders/components/filesModal';
import { uploadFiles, sendBudgetNotification } from 'resources/api/';
import useUser from 'helpers/hooks/useUser';
import RejectBudgetModalLoading from '../accordion/workOrders/components/rejectBudgetModalLoading';

const env = process.env.NODE_ENV.toString();

const ServiceOrders: React.FC = () => {
    const { t } = useTranslation(['common', 'repaircenter']);
    const navigate = useNavigate();
    const [reportSelected, setReportSelected] = useState<string | null>(null);
    const [workOrderState, setWorkOrderState] = useState<WorkOrderRmaLiteDto[]>([]);
    const [rmaFilter, setRmaFilter] = useRecoilState<RmaFilterModel>(FilterAtom);
    const [pendentsRma, setPendentsRma] = useState<string>("");
    const [fileName, setFileName] = useState<string[] | null>([""]);
    const [isRejectModalOpen, setRejectModalOpen] = useState<boolean>(false);
    const [fileUp, setFileUp] = useRecoilState<File[] | null>(RMAFilesAtom);
    const [upLoading, setUpLoading] = useState(false);
    const resetFile = (): void => {
        setFileName([]);
        setFileUp([]);
    };

    const { user: userDetails } = useUser();

    const [, getPendentOS, loading] = useFetch<string>({
        url: REPAIR_CENTER.getPendentOS,
        method: 'POST',
        redirectOnError: true
    });

    const [, resendEmailList, sendingEmailList] = useFetch<RMAandOS[]>({
        url: REPAIR_CENTER.resendEmailList,
        method: 'POST',
        onError: 'Send'
    });

    const [rmaState, setRmaState] = useRecoilState<RmaModelLite>(RmaLite);
    const setNotification = useSetRecoilState(notificationAtom);
    const openRma = 5;
    const [itemsByPage, setItemsByPage] = useState(50); //ALTERAR PRA 50
    const [indice, setIndice] = useState(1);

    const [, getRmaFilter, loadingRmas] = useFetch<RmaFilterModel, RmaFilterModel>({
        url: REPAIR_CENTER.getRmas,
        method: 'POST',
        redirectOnError: true
    });

    useEffect(() => {
        getOpenedRmas();
    }, [itemsByPage]);

    const initialWorkOrderRef = useRef<WorkOrderRmaLiteDto[]>([]);
    const [loadingSendEmail, setLoadingSendEmail] = useState(false);

    useEffect(() => {
        if (pendentsRma?.length !== 0) {
            getPendentOS(pendentsRma, current => {
                setWorkOrderState(current.data);
                initialWorkOrderRef.current = current.data;
            }
            );
        }
        setSelectedRMAandOS([]);
    }, [pendentsRma]);


    const handleCellClick = (row: WorkOrderRmaLiteDto) => {
        navigate('rma-detail');
        setRmaState({ ...rmaState, id: Number(row.rma) });
    }

    const handlePrint = async (workOrder: string): Promise<void> => {
        setReportSelected(workOrder);
        await requestFile.print(REPAIR_CENTER.getTechnicalReportHTML, {
            method: 'POST',
            params: { ids: [workOrder] }
        });
        setReportSelected(null);
    };

    const getOpenedRmas = async () => {
        await getRmaFilter({
            ...rmaFilter,
            indice: indice,
            statusId: openRma,
            id: 0,
            itemsByPage: itemsByPage,
        },
            (resp) => {
                const rmaIds = String(resp.data?.rmas.map(e => e.id).join(","));
                setPendentsRma('"' + rmaIds + '"');
            }

        );
    }

    const [selectedRMAandOS, setSelectedRMAandOS] = useState<RMAandOS[]>([]);
    type RMAandOS = {
        rma: string;
        os: string;
        total: string;
        approvalInfo: ApprovalInfo;
    };
    type ApprovalInfo = {
        userName: string;
        phone: string;
        serviceCNPJ: string;
        serviceEmail: string;
        partsCNPJ: string;
        partsEmail: string;
        emailXML: string;
        obs?: string;
        salesOrder?: boolean;
        fileName: string;
    };

    const handleCheckboxChangeRMAandOS = (rma: string, os: string, total: string) => {
        setSelectedRMAandOS(prev => {
            const exists = prev.some(item => item.rma === rma && item.os === os && item.total === total);
            if (exists) {
                return prev.filter(item => !(item.rma === rma && item.os === os && item.total === total));
            } else {
                return [
                    ...prev,
                    {
                        rma,
                        os,
                        total,
                        approvalInfo: {
                            userName: '',
                            phone: '',
                            serviceCNPJ: '',
                            serviceEmail: '',
                            partsCNPJ: '',
                            partsEmail: '',
                            emailXML: '',
                            obs: '',
                            salesOrder: undefined,
                            fileName: ''
                        }
                    }
                ];
            }
        });
    };

    const [filteredData, setFilteredData] = useState<WorkOrderRmaLiteDto[]>([]);


    useEffect(() => {
        setFilteredData(workOrderState); // Inicializa com todos os dados
    }, [workOrderState]);



    const handleGlobalFilter = (query: string) => {
        const lowerQuery = query.toLowerCase();
        const filtered = workOrderState.filter((item) =>
            item.rma.toLowerCase().includes(lowerQuery)
        );
        setFilteredData(filtered);
    };



    const [budgetPDF, getBudgetPDFList, loadingPDF] = useFetch<rmaToken>({
        url: REPAIR_CENTER.getBudgetPDFList,
        method: 'POST',
        onSuccess: 'Orçamento gerado com sucesso!',
        onError: 'Erro ao gerar o orçamento!'
    });

    useEffect(() => {
        if (budgetPDF?.data) {
            handlePrintOs(budgetPDF.data);
            setIsBudgetReady(false);
        }
    }, [budgetPDF]);

    type rmaToken = {
        url?: string;
        os: string[];
    };


    const [approveOS, setApproveOsList, loadingApprove] = useFetch<RMAandOS[]>({
        url: REPAIR_CENTER.approveOsList,
        method: 'POST',
        onSuccess: 'Ordens de serviço APROVADAS com sucesso!',
        onError: 'Erro ao aprovar!'
    });

    const [reproveOS, setReproveOsList, loadingReprove] = useFetch<RMAandOS[]>({
        url: REPAIR_CENTER.reproveOsList,
        method: 'POST',
        onSuccess: 'Ordens de serviço REPROVADAS com sucesso!',
        onError: 'Erro ao reprovar!'
    });


    const handlePrintOs = async (data: any) => {
        const winPrint = window.open('left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

        if (winPrint) {
            winPrint.document.write(Object.values(data).join(''));
            winPrint.document.close();
            setTimeout(() => {
                winPrint.print();
            }, 200);
        }
    };

    useEffect(() => {
        if (budgetPDF) {
            setIsBudgetReady(true);
        }
    }, [budgetPDF]);

    const [isBudgetReady, setIsBudgetReady] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleSelectAll = () => {
        const selectableItems = filteredData.filter(
            item => item.flagApproved !== 1 && item.flagApproved !== 0
        );

        const makeKey = (rma: string, os: string) => `${rma}-${os}`;

        const allSelectableKeys = selectableItems.map(item =>
            makeKey(item.rma, item.os)
        );

        const selectedKeys = new Set(
            selectedRMAandOS.map(item => makeKey(item.rma, item.os))
        );

        const allSelected = allSelectableKeys.every(key => selectedKeys.has(key));

        if (allSelected) {
            // Remove os que estavam selecionados e pertencem ao filtro atual
            const updatedSelected = selectedRMAandOS.filter(
                item => !allSelectableKeys.includes(makeKey(item.rma, item.os))
            );
            setSelectedRMAandOS(updatedSelected);
        } else {
            const newSelected = selectableItems.map(item => ({
                rma: item.rma,
                os: item.os,
                total: item.workOrderOptional,
                approvalInfo: {
                    userName: '',
                    phone: '',
                    serviceCNPJ: '',
                    serviceEmail: '',
                    partsCNPJ: '',
                    partsEmail: '',
                    emailXML: '',
                    obs: '',
                    salesOrder: undefined,
                    fileName: ''
                }
            }));

            const updatedSelected = [
                ...selectedRMAandOS.filter(
                    item => !allSelectableKeys.includes(makeKey(item.rma, item.os))
                ),
                ...newSelected
            ];
            setSelectedRMAandOS(updatedSelected);
        }
    };


    const handleEmail = async () => {
        const email = userDetails?.email!
        const url = process.env.REACT_APP_USER_API!
        const payload = selectedRMAandOS.map(item => ({
            email,
            osId: Number(item.os),
            rmaId: Number(item.rma),
            total: item.total,
            url,
        }));
        await sendBudgetNotification(payload)
    }

    const [approveUser, setApproveUser] = useState<ApprovalInfo>({
        userName: '',
        phone: '',
        serviceCNPJ: '',
        serviceEmail: '',
        partsCNPJ: '',
        partsEmail: '',
        emailXML: '',
        obs: '',
        salesOrder: undefined,
        fileName: ''
    })

    const [rangeValue, setRangeValue] = useState<{ from: string | Date; to: string | Date }>({ from: '', to: '' });


    const handleRangeSelect = (
        range: { from: Date; to: Date },
        formats?: {
            utc: { from: number; to: number };
            iso: { from: string; to: string };
            dateString: { from: string; to: string };
        }
    ) => {
        if (range.from && range.to) {
            const filteredDate = workOrderState.filter(item =>
                new Date(item.dataEntrada) >= range.from &&
                new Date(item.dataEntrada) <= range.to
            );
            setWorkOrderState(filteredDate);
        }
    };

    const handleUpload = async () => {
        setUpLoading(true); // inicia o loading

        try {
            const upload = await uploadFiles(
                fileUp!,
                selectedRMAandOS[0].rma,
                userDetails?.ssoid!,
                'PEDIDO_COMPRA_LOTE'
            );
            return upload;
        } catch (error) {
            console.error("Erro no upload:", error);
            return null;
        } finally {
            setUpLoading(false); // encerra o loading
        }
    };

    const handleApprove = async () => {
        const updatedList = selectedRMAandOS.map(item => ({
            ...item,
            approvalInfo: { ...approveUser }
        }));

        let allUploadsSuccessful = true;

        if (approveUser.fileName) {
            const upload = await handleUpload();

            if (!upload || upload.status !== 200) {
                allUploadsSuccessful = false;
                setNotification(old => ({ ...old, message: 'UploadError' }));
            }
        }

        if (allUploadsSuccessful) {
            await setApproveOsList(updatedList);
        }

        // Reset de estados e UI
        setSelectedRMAandOS([]);
        setApproveUser({
            userName: '',
            phone: '',
            serviceCNPJ: '',
            serviceEmail: '',
            partsCNPJ: '',
            partsEmail: '',
            emailXML: '',
            obs: '',
            salesOrder: undefined,
            fileName: ''
        });
        resetFile();
        setIsModalOpen(false);

        await getPendentOS(pendentsRma, (current => {
            setWorkOrderState(current.data);
        }));
    };


    const [isFileModalOpen, setFileModalOpen] = useState<boolean>(false);

    function handleValidation(approveUser: {
        userName?: string;
        phone?: string;
        partsCNPJ?: string;
        serviceEmail?: string;
        serviceCNPJ?: string;
        partsEmail?: string;
        emailXML?: string;
        salesOrder?: boolean;
        fileName?: string;
    }): boolean {
        const infoValidation =
            !!approveUser.userName?.trim() &&
            !!approveUser.phone?.trim() &&
            !!approveUser.partsCNPJ?.trim() &&
            !!approveUser.serviceEmail?.trim() &&
            !!approveUser.serviceCNPJ?.trim() &&
            !!approveUser.partsEmail?.trim() &&
            !!approveUser.emailXML?.trim();

        const fileValidation = (
            (approveUser.salesOrder === true && !!approveUser.fileName?.trim()) ||
            (approveUser.salesOrder === false && !approveUser.fileName?.trim())
        );
        return infoValidation && fileValidation;
    }

    const handleReject = async (): Promise<void> => {
        const updatedList = selectedRMAandOS.map(item => ({
            ...item,
            approvalInfo: { ...approveUser }
        }));
        await setReproveOsList(updatedList);
        setSelectedRMAandOS([]);
        setApproveUser({
            userName: '',
            phone: '',
            serviceCNPJ: '',
            serviceEmail: '',
            partsCNPJ: '',
            partsEmail: '',
            emailXML: '',
            obs: '',
            salesOrder: undefined,
            fileName: ''
        });
        setIsModalOpen(false);
        setRejectModalOpen(false)
        await getPendentOS(pendentsRma, (current => {
            setWorkOrderState(current.data)
        }));
    };

    const handleIndicePlus = async (num: number) => {
        setIndice(num + 1)
    };

    const handleIndiceMinus = async (num: number) => {
        if (num = 1 || 0) {
            setIndice(1)
        } else {
            setIndice(num - 1)
        }
    };

    const isButtonDisabled = (): boolean => {
        return loadingPDF || loadingSendEmail || selectedRMAandOS.length === 0;
    };

    const isButtonLoaded = (): boolean => {
        return loadingPDF || loadingSendEmail;
    };

    const approveModal = (): JSX.Element => {
        return (
            <div className='modal'>
                <Modal
                    onClose={() => {
                        setIsModalOpen(false)
                        setApproveUser({
                            userName: '',
                            phone: '',
                            serviceCNPJ: '',
                            serviceEmail: '',
                            partsCNPJ: '',
                            partsEmail: '',
                            emailXML: '',
                            obs: '',
                            salesOrder: undefined,
                            fileName: ''
                        })
                        resetFile();
                    }}
                    closeIcon
                    open={isModalOpen}
                    closeOnDimmerClick
                    closeOnDocumentClick
                >
                    <div className='modal-content'>
                        <Modal.Header>
                            <h3>{t('repaircenter:rma.budget.Approval.Info')}</h3>
                        </Modal.Header>
                        <Modal.Content scrolling>
                            <div className="approval-form">
                                <div className="approval-form-item">
                                    <Input
                                        fluid
                                        label={t('repaircenter:rma.budget.Approval.UserName')}
                                        indicator="required"
                                        value={approveUser.userName}
                                        onChange={(e: string) =>
                                            setApproveUser({ ...approveUser, userName: e })
                                        }
                                    />
                                </div>
                                <div className="approval-form-item">
                                    <Input
                                        fluid
                                        label={t('repaircenter:rma.budget.Approval.Phone')}
                                        indicator="required"
                                        value={approveUser.phone}
                                        onChange={(e: string) =>
                                            setApproveUser({ ...approveUser, phone: telephoneMask(e) })
                                        }
                                    />
                                </div>
                                <div className="approval-form-item">
                                    <Input
                                        fluid
                                        label={t('repaircenter:rma.budget.Approval.ServicesCnpj')}
                                        indicator="required"
                                        value={approveUser.serviceCNPJ}
                                        onChange={(e: string) =>
                                            setApproveUser({ ...approveUser, serviceCNPJ: cnpjMask(e) })
                                        }
                                    />
                                </div>
                                <div className="approval-form-item">
                                    <Input
                                        fluid
                                        label={t('repaircenter:rma.budget.Approval.ServicesEmail')}
                                        indicator="required"
                                        value={approveUser.serviceEmail}
                                        onChange={(e: string) =>
                                            setApproveUser({ ...approveUser, serviceEmail: e })
                                        }
                                    />
                                </div>
                                <div className="approval-form-item">
                                    <Input
                                        fluid
                                        label={t('repaircenter:rma.budget.Approval.PartsCnpj')}
                                        indicator="required"
                                        value={approveUser.partsCNPJ}
                                        onChange={(e: string) =>
                                            setApproveUser({ ...approveUser, partsCNPJ: cnpjMask(e) })
                                        }
                                    />
                                </div>
                                <div className="approval-form-item">
                                    <Input
                                        fluid
                                        label={t('repaircenter:rma.budget.Approval.PartsEmail')}
                                        indicator="required"
                                        value={approveUser.partsEmail}
                                        onChange={(e: string) =>
                                            setApproveUser({ ...approveUser, partsEmail: e })
                                        }
                                    />
                                </div>
                                <div className="approval-form-item">
                                    <Input
                                        fluid
                                        label={t('repaircenter:rma.budget.Approval.EmailXml')}
                                        indicator="required"
                                        value={approveUser.emailXML}
                                        onChange={(e: string) =>
                                            setApproveUser({ ...approveUser, emailXML: e })
                                        }
                                    />
                                </div>
                                <div className="approval-form-item">
                                    <Input
                                        fluid
                                        label={t('repaircenter:rma.budget.Approval.Obs')}
                                        value={approveUser.obs}
                                        onChange={(e: string) =>
                                            setApproveUser({ ...approveUser, obs: e })
                                        }
                                    />
                                </div>
                                <div className="approval-form-item inline-select">
                                    <label className="select-label">
                                        {t('repaircenter:rma.budget.Approval.SalesOrder')}
                                    </label>
                                    <span className='required-dot' />
                                    <Select
                                        className="compact-select"
                                        placeholder="Selecione"
                                        options={[
                                            { value: true, text: 'Sim' },
                                            { value: false, text: 'Não' },
                                        ]}
                                        onChange={(e: boolean) =>
                                            setApproveUser({ ...approveUser, salesOrder: e })
                                        }
                                    />
                                </div>
                                <div className="approval-form-item">
                                    <Button
                                        className='small-button'
                                        icon={<Icon name="attachment" root="common" />}
                                        content="Anexar pedido(s) de compra"
                                        disabled={approveUser.salesOrder === false || approveUser.salesOrder === undefined || userDetails?.role.toLowerCase() == "super"}
                                        onClick={() => setFileModalOpen(true)}
                                    />
                                    {isFileModalOpen && (
                                        <FilesModal
                                            onClose={() => setFileModalOpen(false)}
                                            open={isFileModalOpen}
                                            onAccept={(files: File[]) => {
                                                setFileUp(files);
                                                setFileName(files.map(file => file.name));
                                                setApproveUser({ ...approveUser, fileName: files.map(file => file.name).join(', ') });
                                            }}
                                            onReset={resetFile}
                                        />
                                    )}
                                </div>
                            </div>
                        </Modal.Content>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                            {fileName?.length! >= 2 && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }} onClick={() => {
                                    resetFile();
                                    setApproveUser({ ...approveUser, fileName: "" });
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Icon
                                            size="large"
                                            name="delete"
                                            color="red"
                                            description="Limpar arquivos anexados"
                                            className="clickable"
                                        />
                                        <div style={{ color: 'red', fontFamily: 'Honeywell Sans Web' }}>Limpar</div>
                                    </div>
                                </div>
                            )}
                            <br></br>
                            {fileName?.length !== 0 && (
                                <div>
                                    {fileName?.map((name, index) => (
                                        <div key={index}>{name}</div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <Modal.Footer style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                            <Button
                                primary
                                content="Aprovar"
                                loading={loadingApprove || upLoading}
                                disabled={!handleValidation(approveUser)}
                                onClick={async () => {
                                    await handleApprove();
                                }}
                            />
                        </Modal.Footer>
                    </div>
                </Modal>
            </div>
        )
    };

    return <>
        {approveModal()}
        {isRejectModalOpen && (
            <RejectBudgetModalLoading
                open={isRejectModalOpen}
                onClose={() => setRejectModalOpen(false)}
                onRejects={async () => {
                    await handleReject()
                    getOpenedRmas()
                }}
                loading={loadingReprove}
                onChange={(e: string) => {
                    setApproveUser({ ...approveUser, obs: e })
                }
                }
                osId={selectedRMAandOS.map(item => item.os).join(",")}
            />
        )}
        {
            loading || loadingRmas ? (
                <Loader text={t('common:actions.Loading')} />
            ) : !workOrderState ? (
                <Alert text={t('notification:information.NoData')} />
            ) : (
                <div>
                    <Alert text={t('repaircenter:translation.AlertOS_2')} color='red' />
                    <div style={{ margin: '16px 0' }}></div>
                    <Alert text={t('repaircenter:translation.AlertOS')} />
                    <div style={{ margin: '16px 0', display: 'flex', justifyContent: 'flex-start' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '10px' }}>
                            <DatePicker
                                label={t('repaircenter:translation.Period')}
                                type="daterange"
                                closeOnSelection={true}
                                rangeValue={rangeValue}
                                onRangeSelect={(range, formats) => {
                                    setRangeValue(range);
                                    handleRangeSelect(range, formats);
                                }}
                            />


                            <Button
                                secondary
                                content={t('common:actions.Clean')}
                                onClick={() => {
                                    setWorkOrderState(initialWorkOrderRef.current); // limpa a tabela
                                    setRangeValue({ from: '', to: '' }); // limpa o campo de Período
                                }}
                            />


                        </div>
                        <div style={{ display: 'flex', marginLeft: '30px', marginTop: '29px' }}>
                            {userDetails?.role !== '3' && userDetails?.role !== '4' && (
                                <Select
                                    label="Nº RMAS"
                                    options={[
                                        { value: 20, text: '20' },
                                        { value: 200, text: '200' },
                                        { value: 500, text: '500' },
                                    ]}
                                    onChange={(e: number) => {
                                        setItemsByPage(e);
                                    }}
                                />
                            )}
                        </div>
                        <div
                            className="card-rma"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginLeft: 'auto',
                                textAlign: 'center',
                                width: 'fit-content'
                            }}
                        >

                            <div className='rma-label'>
                                <InputLabel label={t('repaircenter:translation.RMARange')} />
                            </div>
                            <div className="rma-interval" style={{ display: 'flex', gap: '8px', justifyContent: 'center', alignItems: 'center', height: 70 }}>
                                <Input
                                    disabled={true}
                                    value={(() => {
                                        const rmas = pendentsRma?.split(',').map(Number).filter(Boolean);
                                        if (!rmas || rmas.length === 0) return '';
                                        return `${rmas[0]}`;
                                    })()}
                                />
                                <span className='divisor'>-</span>
                                <Input
                                    disabled={true}
                                    value={(() => {
                                        const rmas = pendentsRma?.split(',').map(Number).filter(Boolean);
                                        if (!rmas || rmas.length === 0) return '';
                                        return `${rmas[rmas.length - 1]}`;
                                    })()}
                                />
                            </div>
                            <div style={{ display: 'flex' }}>
                                <Button
                                    primary
                                    content="- RMA"
                                    onClick={async () => {
                                        await handleIndiceMinus(indice);
                                        await getRmaFilter({
                                            ...rmaFilter,
                                            indice: indice - 1,
                                            statusId: openRma,
                                            id: 0,
                                            itemsByPage: itemsByPage
                                        }, (resp) => {
                                            const rmaIds = String(resp.data?.rmas.map(e => e.id).join(","));
                                            setPendentsRma('"' + rmaIds + '"');
                                        });
                                    }}
                                    disabled={indice === 1}
                                />
                                <Button
                                    primary
                                    content="+ RMA"
                                    onClick={async () => {
                                        await handleIndicePlus(indice);
                                        await getRmaFilter({
                                            ...rmaFilter,
                                            indice: indice + 1,
                                            statusId: openRma,
                                            id: 0,
                                            itemsByPage: itemsByPage
                                        }, (resp) => {
                                            const rmaIds = String(resp.data?.rmas.map(e => e.id).join(","));
                                            setPendentsRma('"' + rmaIds + '"');
                                        });
                                    }}
                                />
                            </div>
                        </div>

                    </div>

                    <Card>
                        <div className="table-OS">
                            <DataTable
                                data={filteredData}
                                totalRecords={filteredData.length}
                                paginator
                                rows={10}
                                search
                                searchPlaceholder={t('common:actions.SearchRMA')}
                                onGlobalFilter={handleGlobalFilter}
                                lazy={false}
                            >
                                <DataTable.Column
                                    className='teste'
                                    field="print"
                                    initialWidth={15}
                                    header={<Icon
                                        className='select-all-checkbox'
                                        style={{ cursor: 'pointer' }}
                                        root="common"
                                        name="checkbox"
                                        onClick={handleSelectAll} />}
                                    renderer={(e: { rowData: WorkOrderRmaLiteDto }) => (
                                        <Checkbox
                                            checked={
                                                selectedRMAandOS.some(item =>
                                                    item.rma === e.rowData.rma &&
                                                    item.os === e.rowData.os &&
                                                    item.total === e.rowData.workOrderOptional
                                                ) ||
                                                e.rowData.flagApproved == 1 ||
                                                e.rowData.flagApproved == 0
                                            }
                                            disabled={e.rowData.flagApproved == 1 || e.rowData.flagApproved == 0}
                                            onChange={() => {
                                                handleCheckboxChangeRMAandOS(
                                                    e.rowData.rma,
                                                    e.rowData.os,
                                                    e.rowData.workOrderOptional
                                                )
                                            }}
                                            align="center"
                                        />
                                    )}
                                />
                                <DataTable.Column
                                    field="rma"
                                    header="RMA"
                                    align='center'
                                    sortable
                                />
                                <DataTable.Column
                                    field="os"
                                    header={t('common:translation.OsNumber')}
                                    align='center'
                                    sortable
                                />
                                <DataTable.Column
                                    field="partnumber"
                                    header={t('common:translation.Model')}
                                    align='center'
                                />
                                <DataTable.Column
                                    field="modalidade"
                                    header={t('common:translation.Modality')}
                                    align='center'
                                />
                                <DataTable.Column
                                    field="serial"
                                    header={('SN')}
                                    align='center'
                                />
                                <DataTable.Column
                                    field="status"
                                    header={t('common:translation.Status')}
                                    align='center'
                                />
                                <DataTable.Column
                                    field="flagAppoved"
                                    renderer={e =>
                                        <p>{(e.rowData.flagApproved) === 1
                                            ? 'Aprovado' : e.rowData.flagApproved === 0
                                                ? 'Reprovado' : e.rowData.flagApproved !== 'Aguardando Aprovação'
                                                    ? '-' : e.rowData.flagApproved}</p>}
                                    header={t('status.SituationClient')}
                                    align='center'
                                />
                                <DataTable.Column
                                    field="dataEntrada"
                                    renderer={e => <p>{formatDate(e.rowData.dataEntrada)}</p>}
                                    header={t('repaircenter:rma.service_orders.DateIn')}
                                    align='center'
                                    sortable
                                />
                                <DataTable.Column
                                    field="workOrderOptional"
                                    header={t('repaircenter:translation.Value')}
                                    align='center'
                                    sortable
                                />
                                <DataTable.Column
                                    field=""
                                    align='center'
                                    header={t('translation.Report')}
                                    renderer={e => e.rowData.os == reportSelected ? (
                                        <Icon loading={true} name="refresh" />
                                    ) : (
                                        <Icon
                                            style={{ cursor: 'pointer' }}
                                            root="common"
                                            name="document-report"
                                            size="medium"
                                            onClick={() => handlePrint(e.rowData?.os)}
                                        />
                                    )}
                                />
                            </DataTable>
                        </div>
                    </Card>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '15px'
                    }}>
                        {selectedRMAandOS.length === 0 ? t('repaircenter:translation.NoItemsSelected') : `${selectedRMAandOS.length} ` + t('repaircenter:translation.ItemsSelected')}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '5px' }}>
                        <Button
                            type='primary'
                            loading={isButtonLoaded()}
                            content={t('common:actions.GenerateBudget')}
                            disabled={isButtonDisabled()}
                            icon={<Icon name="document-standard" root="common" />}
                            onClick={async () => {
                                await getBudgetPDFList({ os: selectedRMAandOS.map(item => item.os), url: process.env.REACT_APP_USER_API })
                                setIsBudgetReady(false)
                            }
                            }
                        />
                        <Button
                            type='primary'
                            content={t('repaircenter:rma.budget.Actions.Approve')}
                            loading={isButtonLoaded()}
                            disabled={isButtonDisabled() || userDetails?.role == '1' || userDetails?.role == '2'}
                            onClick={async () => {
                                setIsModalOpen(true);
                            }}
                            icon={<Icon name="check" root="common" />}
                        />
                        <Button
                            type='primary'
                            content={t('repaircenter:rma.budget.Actions.Reprove')}
                            loading={isButtonLoaded()}
                            disabled={isButtonDisabled() || userDetails?.role == '1' || userDetails?.role == '2'}
                            onClick={async () => {
                                setRejectModalOpen(true);
                            }}
                            icon={<Icon name="close" root="common" />}
                        />
                        {(userDetails?.role === '1' || userDetails?.role === '2') && (
                            <Button
                                type='primary'
                                content={t('common:actions.SendEmail')}
                                loading={isButtonLoaded()}
                                disabled={isButtonDisabled()}
                                onClick={async () => {
                                    setLoadingSendEmail(true);
                                    try {
                                        await handleEmail();
                                        setNotification({ message: "Enviado!", type: 'success' });
                                    } catch (error) {
                                        setNotification({ message: "Erro!", type: 'critical' });
                                    } finally {
                                        setLoadingSendEmail(false);
                                    }
                                }}
                                icon={<Icon name="email-unread" root="common" />}
                            />
                        )}

                    </div>
                </div>
            )
        }
    </>
};
export default ServiceOrders;